import { render, staticRenderFns } from "./SecurityAlert.vue?vue&type=template&id=71174d42&scoped=true"
import script from "./SecurityAlert.vue?vue&type=script&lang=js"
export * from "./SecurityAlert.vue?vue&type=script&lang=js"
import style0 from "./SecurityAlert.vue?vue&type=style&index=0&id=71174d42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71174d42",
  null
  
)

export default component.exports